// extracted by mini-css-extract-plugin
export default {"create-coupon":"CreateCoupon_create-coupon__fxdxe","action":"CreateCoupon_action__wWtYj","btn":"CreateCoupon_btn__kllg+"};